/* ==========================================================================
   Solzaleben, minimale afname in de winkelwagen (drawer en /cart).

   - "Auf X Pakete erhöhen" ([data-solza-cart-naar-min]) zet het aantalveld van
     die regel op het minimum en stuurt een change-event; Hyper cart.js werkt
     de winkelwagen dan bij en rendert de regel opnieuw.
   - Zolang er in een winkelwagen (drawer of /cart) een vloer onder het
     minimum zit, staan de Kasse-knop en de express-knoppen uit. Dat zien we
     aan het blok [data-solza-cart-onder-min] (Liquid, snippet
     solza-cart-minimum) en, tijdens het typen, aan een aantalveld met een
     waarde onder data-min. Na elke wijziging opnieuw (MutationObserver).
   ========================================================================== */
(function () {
  'use strict';

  if (window.SolzaCartMinimum) return;
  window.SolzaCartMinimum = true;

  // De winkelwagen waar een element bij hoort: de drawer of de /cart-pagina.
  function bereik(el) {
    return el.closest('cart-drawer') || document.getElementById('MainContent') || document.body;
  }

  function onderMinimum(scope) {
    if (scope.querySelector('[data-solza-cart-onder-min]')) return true;
    var velden = scope.querySelectorAll('input[name="updates[]"][data-min]');
    for (var i = 0; i < velden.length; i++) {
      var min = parseInt(velden[i].dataset.min, 10);
      var waarde = parseInt(velden[i].value, 10);
      // Alleen vloeren hebben een blok of data-min > 0; 0 = verwijderen, dat mag.
      if (min > 0 && waarde > 0 && waarde < min && velden[i].offsetParent !== null) return true;
    }
    return false;
  }

  function bijwerken() {
    var knoppen = document.querySelectorAll('button[name="checkout"]');
    knoppen.forEach(function (knop) {
      var scope = bereik(knop);
      var blok = onderMinimum(scope);
      knop.disabled = blok;
      if (blok) knop.setAttribute('aria-disabled', 'true');
      else knop.removeAttribute('aria-disabled');
      scope.classList.toggle('solza-kasse-geblokkeerd', blok);
      scope.querySelectorAll('[data-solza-express]').forEach(function (el) { el.hidden = blok; });
      var hint = knop.parentElement.querySelector('[data-solza-kasse-hint]');
      if (!hint) {
        hint = document.createElement('p');
        hint.setAttribute('data-solza-kasse-hint', '');
        hint.textContent = 'Erhöhe zuerst die Menge, dann kannst du zur Kasse.';
        knop.insertAdjacentElement('afterend', hint);
      }
      hint.hidden = !blok;
    });
  }

  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-solza-cart-naar-min]');
    if (!knop) return;
    event.preventDefault();
    var index = knop.getAttribute('data-index');
    var min = knop.getAttribute('data-solza-cart-naar-min');
    // Het aantalveld van dezelfde regel in dezelfde winkelwagen.
    var scope = bereik(knop);
    var veld = scope.querySelector('input[name="updates[]"][data-index="' + index + '"]');
    if (!veld) return;
    veld.value = min;
    veld.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Tijdens het typen al uitzetten, niet pas na het verversen.
  document.addEventListener('input', function (event) {
    if (event.target.matches && event.target.matches('input[name="updates[]"]')) bijwerken();
  });

  var wacht = null;
  new MutationObserver(function () {
    clearTimeout(wacht);
    wacht = setTimeout(bijwerken, 50);
  }).observe(document.body, { childList: true, subtree: true });

  // Voor het geval de checkout toch via het formulier verstuurd wordt (Enter).
  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (submitter && submitter.name === 'checkout' && onderMinimum(bereik(submitter))) {
      event.preventDefault();
      bijwerken();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bijwerken);
  } else {
    bijwerken();
  }
})();
